"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _edsconfig = _interopRequireDefault(require("./edsconfig.js"));

var cdnBaseUrlWithVersion = "" + _edsconfig.default.cdnBaseUrl + _edsconfig.default.appVersion;

var getLargeIllustrationsUrl = function getLargeIllustrationsUrl(assetName) {
  return cdnBaseUrlWithVersion + "/img/illustrations/large/" + assetName;
};

var getFontsUrl = function getFontsUrl() {
  return cdnBaseUrlWithVersion + "/fonts/fonts.css";
};

var getBackgroundImageUrl = function getBackgroundImageUrl(assetName) {
  return cdnBaseUrlWithVersion + "/img/bg/" + assetName;
};

var getFavIconUrl = function getFavIconUrl(assetName) {
  return assetName ? cdnBaseUrlWithVersion + "/img/favicons/" + assetName : cdnBaseUrlWithVersion + "/img/favicons/favicon.svg";
};

var cdn = {
  getLargeIllustrationsUrl: getLargeIllustrationsUrl,
  getFontsUrl: getFontsUrl,
  getBackgroundImageUrl: getBackgroundImageUrl,
  getFavIconUrl: getFavIconUrl
};
var _default = cdn;
exports.default = _default;